<template>
    <div>
        <nav-bar />
        <v-container class="mt-10 pt-5">
            <!-- Title section -->
            <header-page titleText="Template Padrão" titleIcon="fal fa-user" />

            <!-- Duplicar o container para cada bloco  -->
            <v-container>
                <v-card elevation="8">
                    <!--card title-->
                    <v-card-title class="pb-0">
                        <v-container>
                            <span class="list-labels">Titulo do bloco</span>
                        </v-container>
                    </v-card-title>

                    <!--card content-->
                    <v-card-text class="py-0">
                        <v-container>
                            <v-row>
                                <!-- avatar ###################################### -->
                                <v-col>Conteudo do bloco</v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        color="secondary"
                                        rounded
                                        large
                                        depressed
                                        @click="dialog = true"
                                    >
                                        <v-icon class="mr-3" color="white" small>fal fa-browser</v-icon>Simple Dialog
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        color="secondary"
                                        rounded
                                        large
                                        depressed
                                        @click="dialog1 = true"
                                    >
                                        <v-icon class="mr-3" color="white" small>fal fa-browser</v-icon>Scrollable Dialog
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-container>

            <!-- Footer de submit para o formulario -->
            <v-footer fixed color="transparent" padless class="justify-center">
                <v-card elevation="6" class="pt-3 pb-4 px-4 footer-card">
                    <v-btn color="secondary" rounded large depressed class="px-12">Submit text</v-btn>
                </v-card>
            </v-footer>
        </v-container>

        <!-- Simple Dialog -->
        <v-dialog v-model="dialog" persistent max-width="490">
            <v-card>
                <v-card-title>
                    <h5 class="pt-5 pb-7">Título da Modal</h5>
                </v-card-title>
                <v-card-text>Conteúdo da modal</v-card-text>
                <v-card-actions class="px-6 py-5">
                    <v-spacer />
                    <v-btn large depressed text class="px-6 gray" @click="dialog = false">Voltar</v-btn>
                    <v-btn color="primary" large depressed text class="px-6">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Scrollable Dialog -->
        <v-dialog v-model="dialog1" scrollable persistent max-width="490">
            <v-card>
                <v-card-title>
                    <h5 class="pt-5 pb-7">Título da Modal</h5>
                </v-card-title>
                <v-card-text>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Reprehenderit natus, dolor vero facere magnam corporis officiis porro iure voluptates, amet possimus rem vitae velit, odio reiciendis. Quod voluptatum doloribus fuga!
                    Delectus recusandae possimus illo cum deleniti doloribus nobis minus consectetur earum provident, aspernatur doloremque adipisci iste ad. Reprehenderit suscipit, inventore saepe laudantium fugit id. Perspiciatis, doloribus rerum! Dignissimos, nemo earum.
                    Dicta ducimus ipsa ratione amet suscipit impedit voluptatem commodi libero odio animi est nam quibusdam quod rerum porro rem, et dolores aut deleniti hic quam cum enim? Iusto, dignissimos velit!
                    Expedita deleniti pariatur, nostrum quidem quos cumque quas, quaerat ratione distinctio voluptatibus et tempora asperiores quisquam sequi! Voluptatum, quibusdam. Delectus recusandae quaerat error rem nobis saepe eligendi adipisci vero repellat?
                    Corporis deserunt eos eius inventore vero, similique eveniet a repellat quae doloremque sit et nam sapiente facere enim repellendus tenetur sequi magni corrupti. Culpa itaque, temporibus quidem illum necessitatibus nisi!
                    Mollitia magni error ad aliquam fugit nam eveniet expedita iste aliquid aperiam laudantium vero nulla, nesciunt, fuga quidem esse? Aspernatur animi assumenda fuga illum quos tenetur molestiae explicabo repellendus voluptates.
                    Dolorem amet maxime, vitae dolorum ad tempora, quis consequuntur in quod praesentium, officiis tempore eos exercitationem eaque laboriosam placeat atque debitis. Velit veniam atque, aut quisquam magni ut suscipit cum.
                    Illum molestiae illo aspernatur commodi, eos aliquid nihil quisquam suscipit voluptates explicabo tempore autem cupiditate nemo similique ullam doloribus corporis, delectus repellendus non perspiciatis quos blanditiis voluptas eius? Debitis, sint.
                    Repudiandae aut in suscipit magnam repellat. Tempore, aspernatur corrupti temporibus facere, voluptates cum dolores, quibusdam facilis eveniet saepe veritatis? Enim in veritatis odio quia atque aut ipsam veniam praesentium porro.
                    Error tenetur voluptates obcaecati cumque eos ipsa sint cum nesciunt nostrum, libero sed reprehenderit totam at quam pariatur aliquid recusandae facilis quae exercitationem, corporis quo non, eligendi repellat repudiandae. In?
                </v-card-text>
                <v-divider class="lg" />
                <v-card-actions class="px-6 py-5">
                    <v-btn
                        large
                        rounded
                        outlined
                        depressed
                        class="px-12 gray"
                        @click="dialog1 = false"
                    >Voltar</v-btn>
                    <v-spacer />
                    <v-btn color="primary" large rounded depressed class="px-12">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import HeaderPage from "@/components/HeaderPage";
export default {
    name: "New",
    inject: ["theme"],  
    components: {
        NavBar,
        HeaderPage
    },
    data: () => ({
        dialog: false,
        dialog1: false
    })
};
</script>